/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
import './investAgent.css';

function InvestAgent() {
  const formRef = useRef();
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    let timeout;

    if (submitted || error) {
      timeout = setTimeout(() => {
        setSubmitted(false);
        setError(false);
      }, 5000);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [submitted, error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSfifLUaIGJ_7sD1Hdd17i1fLkCzwgxAwneUvVCliczMyHMILQ/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          body: formData,
        },
      );

      setSubmitted(true);
      setError(false);
      formRef.current.reset(); // optional: reset the form after submit
    } catch (error) {
      console.error('Form submission error:', error);
      setError(true);
      setSubmitted(false);
    }
  };

  return (
    <div className="english-agent-container">
      <div className="container">
        <div className="form-container">
          <h1 className="form-title">Investment Agent</h1>
          <div className="form-intro">
            <p>
              This agent is a
              <strong> DEMO </strong>
              product, created exclusively for financial advisors exploring ways to add AI-powered features to their website.
            </p>

            <p>
              After submitting the form, this assistant will send a personalized response to your email based on the information you provide.
              <strong> Please enter the email address where youd like to receive your guidance.</strong>
            </p>

            <p>
              <i>
                *Each agents logic, design, and contextual training data can be fully tailored to meet the specific requirements of your application.
                <br />
                <br />
                **As the admin, youre instantly notified of every user prompt, the AI-generated response, submitted contact information, and access to request history.
              </i>
            </p>

            <p>
              <strong>NOTE: </strong>
              If youd like to learn more on how to offer this experience to your own clients or website visitors, you can book a meeting with me here:
              <a className="calendly" href="https://calendly.com/me-giojuliao/30min" target="_blank" rel="noopener noreferrer"> Calendly.</a>
              <div>
                <br />
                <a href="https://www.loom.com/share/a810a20982154e6b9f20888058b0f68f" target="_blank" rel="noopener noreferrer">
                  Watch the quick explainer video.
                </a>
              </div>
            </p>
            <p>
              <strong className="form-intro-warning">Important: This form response is for informational DEMO purposes only and should not be used without guidance from a qualified professional.</strong>
            </p>
          </div>
          <div className="required-note">
            <span className="required-symbol">*</span>
            indicates required field
          </div>

          <form className="form" onSubmit={handleSubmit} ref={formRef}>
            {/* Email Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="entry.822093947"
                  required
                  className="form-input"
                  placeholder="tim@apple.com"
                />
                <label htmlFor="email" className="select-label required">
                  Email
                </label>
              </div>
            </div>

            {/* Life Stage  Field (Post as default, Article unavailable) */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="life-stage"
                  name="entry.1962960298"
                  className="form-select"
                  defaultValue=""
                  required
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Early Career">Early Career</option>
                  <option value="Mid Career">Mid Career</option>
                  <option value="Pre-retirement">Pre-retirement</option>
                </select>
                <label htmlFor="life-stage" className="select-label required">
                  Life Stage
                </label>
              </div>
            </div>

            {/* Residence Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="residence"
                  name="entry.868222283"
                  required
                  className="form-input"
                  placeholder="Spain"
                />
                <label htmlFor="residence" className="select-label required">
                  Country Of Residence
                </label>
              </div>
            </div>

            {/* Risk Tolerance  Field (Post as default, Article unavailable) */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="risk-tolerance"
                  name="entry.625686177"
                  className="form-select"
                  defaultValue=""
                  required
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                </select>
                <label htmlFor="risk-tolerance" className="select-label required">
                  Risk Tolerance
                </label>
              </div>
            </div>

            {/* Investment Goals Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="investment-goals"
                  name="entry.394958303"
                  className="form-select"
                  defaultValue=""
                  required
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Retirement">Retirement</option>
                  <option value="Passive Income">Passive Income</option>
                  <option value="High growth">High growth</option>
                  <option value="Preservation">Preservation</option>
                </select>
                <label htmlFor="investment-goals" className="select-label required">
                  Investment Goals
                </label>
              </div>
            </div>

            {/* Investment Experience Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="investment-experience"
                  name="entry.117160788"
                  className="form-select"
                  defaultValue=""
                  required
                >
                  <option value="" disabled>Select an option</option>
                  <option value="Beginner">Beginner</option>
                  <option value="Intermediate">Intermediate</option>
                  <option value="Advance">Advance</option>
                </select>
                <label htmlFor="investment-experience" className="select-label required">
                  Investment Experience Level
                </label>
              </div>
            </div>

            {/* Preferred Markets Field */}
            <div className="form-group">
              <div className="select-container form-input">

                <label className="checkbox-option">
                  <input
                    type="checkbox"
                    name="entry.616372313"
                    value="Stocks"
                    className="form-checkbox"
                  />
                  Stocks
                </label>

                <label className="checkbox-option">
                  <input
                    type="checkbox"
                    name="entry.616372313"
                    value="ETFs"
                    className="form-checkbox"
                  />
                  ETFs
                </label>

                <label className="checkbox-option">
                  <input
                    type="checkbox"
                    name="entry.616372313"
                    value="Real Estate"
                    className="form-checkbox"
                  />
                  Real Estate
                </label>

                <label className="checkbox-option">
                  <input
                    type="checkbox"
                    name="entry.616372313"
                    value="Crypto"
                    className="form-checkbox"
                  />
                  Crypto
                </label>

                <label htmlFor="preferred-markets" className="select-label required checkbox-label">
                  Prefered Markets
                </label>
              </div>
            </div>

            {/* Others Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="other"
                  name="entry.633357561"
                  className="form-input"
                  placeholder="Open to fiat"
                />
                <label htmlFor="other" className="select-label">
                  Other considerations
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <div className="required-note consent">
              <span className="required-symbol">*</span>
              <p>By submitting this form, you agree to be contacted via email with your personalized content and occasional updates related to this service.</p>
            </div>
            <div className="button-container">
              <button
                type="submit"
                className="submit-button"
              >
                Submit
              </button>
              <div className="submit-button-response">
                {submitted && (
                  <div className="form-success-message">
                    🎉 Thanks! Your response has been submitted.
                  </div>
                )}

                {error && (
                <div className="form-error-message">
                  ❌ Oops! Something went wrong. Please try again in a few seconds.
                </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default InvestAgent;
